import { render, staticRenderFns } from "./couponPropertyUserManageList.vue?vue&type=template&id=00a5cd8c&scoped=true"
import script from "./couponPropertyUserManageList.vue?vue&type=script&lang=js"
export * from "./couponPropertyUserManageList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyUserManageList.vue?vue&type=style&index=0&id=00a5cd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5cd8c",
  null
  
)

export default component.exports